import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-paymentfailed',
  templateUrl: './paymentfailed.component.html',
  styleUrls: ['./paymentfailed.component.css']
})
export class PaymentfailedComponent implements OnInit {

  parentRouteParam !: '';
  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    if (this.activatedRoute.parent) {
      this.activatedRoute.parent.params.subscribe(params => {
        this.parentRouteParam = params['storename'];
      });
    }
  }

  fn_RedirectToCart() {
    this.router.navigate([ this.parentRouteParam + '/cart']);
  }
}
